import { useTranslation } from "react-i18next";
import { CompanyPanel } from "./CompanyPanel";
import { DebtLedger } from "./DebtLedger";
import { DiscountsPanel } from "./DiscountsPanel";
import { InventoryPanel } from "./InventoryPanel";
import { KpiCards } from "./KpiCards";
import { QuoteGenerator } from "./QuoteGenerator";
import { ZReport } from "./ZReport";
import { FeatureSettings } from "../v2/FeatureSettings";
import { isV2 } from "../../lib/config";

/** Managers' hub: today's numbers, the credit (ذمم) ledger, quotations, stock and the cash drawer. */
export function AdminHub() {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <div className="card flex items-center gap-3.5 p-5">
        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-gradient-to-tr from-cosmic-purple to-solar-orange text-2xl shadow-cosmic" aria-hidden>📊</div>
        <div>
          <h1 className="text-xl font-black tracking-tight">{t("admin.title")}</h1>
          <p className="text-xs font-medium text-gray-500">{t("admin.subtitle")}</p>
        </div>
      </div>
      <KpiCards />
      <div className="grid grid-cols-1 items-start gap-5 xl:grid-cols-12">
        <div className="space-y-5 xl:col-span-7">
          <DebtLedger />
          <DiscountsPanel />
          <QuoteGenerator />
        </div>
        <div className="space-y-5 xl:col-span-5">
          <InventoryPanel />
          <ZReport />
          <CompanyPanel />
          {isV2() && <FeatureSettings />}
        </div>
      </div>
    </div>
  );
}
